export enum OptionType {
    PUT  = 'PUT',
    CALL = 'CALL'
}

export const OPTION_TYPE_NAMING: Record<OptionType, string> = {
    [OptionType.PUT]:  'enums.option-type.put',
    [OptionType.CALL]: 'enums.option-type.call'
};
